import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardList } from "lucide-react";

const KIND_LABEL = { member: "Member", fee_payment: "Fee payment", ledger: "Ledger entry", camp: "Camp" };
const STATUS = {
  pending: { label: "Awaiting approval", variant: "secondary" },
  approved: { label: "Deleted", variant: "default" },
  rejected: { label: "Kept by admin", variant: "destructive" },
};

export default function MyRequests() {
  const { user } = useAuth();
  const [requests, setRequests] = useState([]);
  const isStandard = user && user.role !== "admin";

  useEffect(() => {
    if (!isStandard) return;
    api.get("/deletion-requests/mine").then((r) => setRequests(r.data)).catch(() => setRequests([]));
  }, [isStandard]);

  if (!isStandard || requests.length === 0) return null;

  return (
    <Card className="card-shadow-soft" data-testid="my-requests">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <ClipboardList className="w-5 h-5 text-primary" />
          <h2 className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>My deletion requests</h2>
          <span className="text-xs text-muted-foreground">Deletions you've asked for and what the admin decided</span>
        </div>
        <div className="space-y-1">
          {requests.slice(0, 8).map((r) => {
            const st = STATUS[r.status] || { label: r.status, variant: "secondary" };
            return (
              <div key={r.id} data-testid={`my-request-${r.id}`} className="flex items-center justify-between gap-3 py-2 border-b border-border last:border-0 text-sm">
                <div className="min-w-0">
                  <div className="font-medium truncate"><span className="scout-tag bg-secondary text-foreground mr-2">{KIND_LABEL[r.kind] || r.kind}</span>{r.label}</div>
                  <div className="text-xs text-muted-foreground">Requested {r.created_at.slice(0, 10)}{r.resolved_by_name ? ` · decided by ${r.resolved_by_name}` : ""}</div>
                </div>
                <Badge variant={st.variant} data-testid={`my-request-status-${r.id}`} className="shrink-0">{st.label}</Badge>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
